export default __webpack_public_path__ + "static/media/animalplanet.91f5802a.png";